module.exports = __webpack_public_path__ + "img/result-detail-invest-inleft01.0da59e54.svg";